// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_v08iz","header":"header_L2VqE","left":"left_SFbJ4","logo":"logo_fC9w2"};